import type { AppCheckTokenKind } from '#shared/appCheck'

type GetAppCheckToken = (options?: { limitedUse?: boolean }) => Promise<string | null>

/**
 * An App Check token of the requested kind from `app/plugins/firebase.client.ts`, or `null` (the
 * emulator, no site key, or attestation failed — the server then answers 401 `app_check_required`).
 * Calling this is what initializes App Check, so call it only for a request that needs a token.
 */
export async function appCheckTokenFor(nuxtApp: unknown, kind: AppCheckTokenKind): Promise<string | null> {
  const getAppCheckToken = (nuxtApp as { $getAppCheckToken?: GetAppCheckToken }).$getAppCheckToken
  return (await getAppCheckToken?.({ limitedUse: kind === 'limited' })) ?? null
}
